import * as types from './constants';

// Reset Account Password
export const resetAccountPasswordRequest = data => (
  { type: types.RESET_ACCOUNT_PASSWORD_REQUEST, payload: data }
);

export const resetAccountPasswordDone = data => (
  { type: types.RESET_ACCOUNT_PASSWORD_DONE, payload: data }
);

export const resetAccountPasswordFailed = errors => (
  { type: types.RESET_ACCOUNT_PASSWORD_FAILED, payload: errors }
);

export const resetAccountPasswordReset = () => (
  { type: types.RESET_ACCOUNT_PASSWORD_RESET }
);